import { testId } from 'ui-components/services/testid-service';

import { CustomsTextInput } from '../customs-text-input';

import commonStyle from '../common-style.module.less';

type QuantityInputProps = {
  onChange: (value: string | number) => void;
  value?: number;
  'aria-label'?: string;
};

export const QuantityInput = ({ onChange, value = 0, 'aria-label': ariaLabel = '' }: QuantityInputProps) => {
  return (
    <CustomsTextInput
      {...testId('customs-widget-quantity-input')}
      aria-label={ariaLabel}
      className={commonStyle['quantity-input']}
      onChange={onChange}
      type='number'
      value={value}
    />
  );
};
